// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__NiIYi","containerList":"Spinner_containerList__1QiPp"};